import { z } from 'zod'
import { monosanFetch } from '@/shared/api/monosanFetch'

const transactionSchema = z.object({
  id: z.string(),
  amount: z.object({
    value: z.number(),
    currency: z.string(),
  }),
  createdAt: z.string(),
  counterpartyName: z.string().nullable(),
  counterpartyIban: z.string().nullable(),
  reference: z.string().nullable(),
  status: z.enum(['ON_HOLD', 'COMPLETED', 'REJECTED', 'UNKNOWN']),
})

const transactionsResponseSchema = z.object({
  transactions: z.array(transactionSchema),
})

export type Transaction = z.infer<typeof transactionSchema>

export const getTransactions = (): Promise<z.infer<typeof transactionsResponseSchema>> =>
  monosanFetch('/api/accounts/preferred/transactions', {
    schema: transactionsResponseSchema,
  })
